(() => {
  'use strict';

  const selector = '[data-custom-gallery-video]';

  const updateState = (videoCard) => {
    const video = videoCard.querySelector('video');
    const playButtons = videoCard.querySelectorAll('[data-custom-gallery-video-play]');
    const soundButton = videoCard.querySelector('[data-custom-gallery-video-sound]');

    if (!video) return;

    videoCard.classList.toggle('is-playing', !video.paused);
    videoCard.classList.toggle('is-unmuted', !video.muted);

    playButtons.forEach((playButton) => {
      playButton.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      playButton.setAttribute('aria-pressed', String(!video.paused));
    });

    const centerPlayButton = videoCard.querySelector('.product-gallery__custom-video-play');
    const cornerPlayButton = videoCard.querySelector('.product-gallery__custom-video-corner-play');

    if (centerPlayButton) {
      centerPlayButton.tabIndex = video.paused ? 0 : -1;
      centerPlayButton.setAttribute('aria-hidden', String(!video.paused));
    }

    if (cornerPlayButton) {
      cornerPlayButton.tabIndex = video.paused ? -1 : 0;
      cornerPlayButton.setAttribute('aria-hidden', String(video.paused));
    }

    if (soundButton) {
      soundButton.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Mute video');
      soundButton.setAttribute('aria-pressed', String(!video.muted));
    }
  };

  const pauseVideo = (videoCard) => {
    const video = videoCard.querySelector('video');

    if (!video || video.paused) return;

    video.pause();
  };

  const updateGalleryBadgeVisibility = (carousel, activeCell = carousel.selectedCell) => {
    const imageList = carousel.closest('.product-gallery__image-list');

    if (!imageList) return;

    imageList.classList.toggle(
      'has-active-custom-gallery-video',
      activeCell?.dataset.mediaType === 'custom_video'
    );
  };

  document.addEventListener('click', (event) => {
    const video = event.target.closest(`${selector} video`);

    if (!video || video.paused) return;

    event.preventDefault();
    event.stopPropagation();
    video.pause();
    updateState(video.closest(selector));
  });

  document.addEventListener('click', (event) => {
    const playButton = event.target.closest('[data-custom-gallery-video-play]');
    const soundButton = event.target.closest('[data-custom-gallery-video-sound]');
    const button = playButton || soundButton;

    if (!button) return;

    const videoCard = button.closest(selector);
    const video = videoCard?.querySelector('video');

    if (!video) return;

    event.preventDefault();
    event.stopPropagation();

    if (playButton) {
      if (video.paused) {
        const isFirstPlayButton = playButton.classList.contains('product-gallery__custom-video-play');

        if (isFirstPlayButton && videoCard.dataset.startUnmuted === 'true') {
          video.muted = false;
        }

        video.play().catch(() => updateState(videoCard));
      } else {
        video.pause();
      }
    } else {
      video.muted = !video.muted;
    }

    updateState(videoCard);
  });

  document.addEventListener('play', (event) => {
    const video = event.target;

    if (!video.matches(`${selector} video`)) return;

    document.querySelectorAll(`${selector} video`).forEach((otherVideo) => {
      if (otherVideo !== video && !otherVideo.paused) {
        otherVideo.pause();
      }
    });

    updateState(video.closest(selector));
  }, true);

  document.addEventListener('pause', (event) => {
    if (event.target.matches(`${selector} video`)) {
      updateState(event.target.closest(selector));
    }
  }, true);

  document.addEventListener('volumechange', (event) => {
    if (event.target.matches(`${selector} video`)) {
      updateState(event.target.closest(selector));
    }
  }, true);

  document.addEventListener('carousel:change', (event) => {
    const nextCell = event.detail?.cell;

    if (!nextCell || !event.target.matches('.product-gallery__carousel')) return;

    updateGalleryBadgeVisibility(event.target, nextCell);

    event.target.querySelectorAll(selector).forEach((videoCard) => {
      if (!nextCell.contains(videoCard)) pauseVideo(videoCard);
    });
  }, true);

  document.querySelectorAll('.product-gallery__carousel').forEach((carousel) => {
    updateGalleryBadgeVisibility(carousel);
  });

  document.querySelectorAll(selector).forEach(updateState);
})();
